<script setup>
import OneTimeLinkGenerator from "@/components/OneTimeLinkGenerator.vue";
</script>

<template>
  <div class="container mt-5">
    <button @click="showGenerator = true" class="btn btn-outline-light mx-2">One-time URL</button>
    <OneTimeLinkGenerator v-if="showGenerator" @close="showGenerator = false" />
    <button class="btn btn-outline-light mx-2" @click="spectate">Spectation</button>
    <button class="btn btn-outline-light mx-2" @click="manage">Management</button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showGenerator: false,
    };
  },
  mounted() {
  },
  methods: {
    spectate() {
      this.$router.push('/spectator?roomId=room3,room4');
    },
    manage() {
      this.$router.push('/manager');
    }
  }
};
</script>

<style scoped>
</style>

